import { useState, useEffect } from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';

export interface UserData {
  email: string;
  groups: string[];
}

enum Status {
  CONFIGURING = 'configuring',
  AUTHORIZED = 'authorized',
  UNAUTHORIZED = 'unauthorized'
}

declare const window: {
  location: {
    pathname: string;
  };
  hideMintMedicalStoreLogoutNavLink: () => void;
  showMintMedicalStoreAccountNavLink: () => void;
  showMintMedicalStoreLogoutNavLink: () => void;
  hideMintMedicalStoreAccountNavLink: () => void;
};

export function useUserData() {
  const [status, setStatus] = useState<string>(Status.CONFIGURING);
  const [accessToken, setAccessToken] = useState<unknown>(undefined);
  const [idToken, setIdToken] = useState<unknown>(undefined);
  const [userData, setUserData] = useState<UserData | undefined>({
    email: '',
    groups: []
  });

  useEffect(() => {
    return Hub.listen('auth', (data) => {
      if (data.payload.event === 'signedOut') {
        if (isInAccount()) {
          window.showMintMedicalStoreLogoutNavLink && window.showMintMedicalStoreLogoutNavLink();
          window.hideMintMedicalStoreAccountNavLink && window.hideMintMedicalStoreAccountNavLink();
        } else {
          window.hideMintMedicalStoreLogoutNavLink && window.hideMintMedicalStoreLogoutNavLink();
          window.showMintMedicalStoreAccountNavLink && window.showMintMedicalStoreAccountNavLink();
        }

        setUserData({ email: '', groups: [] });

        setIdToken(undefined);

        setAccessToken(undefined);

        setStatus(Status.UNAUTHORIZED);

        return;
      }

      _setUp();
    });
  }, []);

  useEffect(() => {
    _setUp();

    return () => {
      setStatus(Status.UNAUTHORIZED);

      setUserData(undefined);

      setIdToken(undefined);

      setAccessToken(undefined);
    };
  }, []);

  function _setUp() {
    fetchAuthSession().then((p) => {
      try {
        setStatus(Status.AUTHORIZED);

        const idToken = p.tokens?.idToken;

        const groups = JSON.parse(JSON.stringify(p.tokens?.idToken?.payload))['cognito:groups'] as Array<string>;

        setUserData({ email: idToken?.payload?.email as string, groups });

        setIdToken(idToken);

        setAccessToken(p.tokens?.accessToken);

        if (isInAccount()) {
          window.showMintMedicalStoreLogoutNavLink && window.showMintMedicalStoreLogoutNavLink();
          window.hideMintMedicalStoreAccountNavLink && window.hideMintMedicalStoreAccountNavLink();
        } else {
          window.hideMintMedicalStoreLogoutNavLink && window.hideMintMedicalStoreLogoutNavLink();
          window.showMintMedicalStoreAccountNavLink && window.showMintMedicalStoreAccountNavLink();
        }
      } catch (error) {
        // console.log(error);

        setUserData({ email: '', groups: [] });

        setIdToken(undefined);

        setAccessToken(undefined);

        setStatus(Status.UNAUTHORIZED);

        window.hideMintMedicalStoreLogoutNavLink && window.hideMintMedicalStoreLogoutNavLink();
        window.showMintMedicalStoreAccountNavLink && window.showMintMedicalStoreAccountNavLink();
      }
    });
  }

  return { userData, accessToken, idToken, status };
}

function isInAccount() {
  const isInAccount = window.location.pathname.startsWith('/account');
  console.debug('pathname', window.location.pathname);
  console.debug('isInAccount', isInAccount);
  return isInAccount;
}
